module.exports = __webpack_public_path__ + "img/Number=12.266d84f0.png";